import { render, staticRenderFns } from "./Vip_reload.vue?vue&type=template&id=4af5e547&"
import script from "./Vip_reload.vue?vue&type=script&lang=js&"
export * from "./Vip_reload.vue?vue&type=script&lang=js&"
import style0 from "./Vip_reload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports